(function () {
  'use strict';

  var header = document.querySelector('[data-custom-header]');
  if (!header) return;

  /* ------------------------------------------------------------------ */
  /* Sticky header                                                       */
  /* ------------------------------------------------------------------ */

  var stickyMode = header.getAttribute('data-sticky');
  var lastScroll = window.scrollY;
  var ticking = false;

  function handleSticky() {
    var current = window.scrollY;

    if (stickyMode === 'always' || stickyMode === 'always-reduce-logo') {
      header.classList.toggle('is-pinned', current > 20);
    } else if (stickyMode === 'on-scroll-up') {
      if (current > 80 && current > lastScroll) {
        header.classList.add('is-scrolled-down');
        header.classList.add('is-stuck');
      } else if (current < lastScroll) {
        header.classList.remove('is-scrolled-down');
        header.classList.add('is-stuck');
      }
      if (current <= 20) {
        header.classList.remove('is-stuck');
        header.classList.remove('is-scrolled-down');
      }
      header.classList.toggle('is-pinned', current > 20);
    }

    lastScroll = current;
    ticking = false;
  }

  if (stickyMode && stickyMode !== 'none') {
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(handleSticky);
        ticking = true;
      }
    }, { passive: true });
  }

  /* ------------------------------------------------------------------ */
  /* Search toggle                                                       */
  /* ------------------------------------------------------------------ */

  var searchToggle = document.querySelector('[data-search-toggle]');
  var searchForm = document.querySelector('[data-search-form]');

  if (searchToggle && searchForm) {
    searchToggle.addEventListener('click', function () {
      var isHidden = searchForm.hasAttribute('hidden');
      if (isHidden) {
        searchForm.removeAttribute('hidden');
        searchForm.querySelector('input').focus();
      } else {
        searchForm.setAttribute('hidden', '');
      }
    });
  }

  var menuOpenBtn  = document.querySelector('[data-menu-open]');
  var menuCloseBtn = document.querySelector('[data-menu-close]');
  var overlay      = document.querySelector('[data-menu-overlay]');
  var menu         = document.querySelector('[data-mobile-menu]');
  var panelsWrap   = document.querySelector('[data-panels]');
  var panels       = panelsWrap.querySelectorAll('.mobile-panel');

  function openMenu(){
    menu.classList.add('is-open');
    overlay.classList.add('is-open');
    menu.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeMenu(){
    menu.classList.remove('is-open');
    overlay.classList.remove('is-open');
    menu.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    // reset to main panel after the close transition finishes
    setTimeout(resetPanels, 300);
  }
  function resetPanels(){
    panels.forEach(function(p){
      p.classList.remove('is-active', 'is-prev');
    });
  }

  function gotoPanel(name){
    var target = panelsWrap.querySelector('[data-panel="' + name + '"]');
    var current = panelsWrap.querySelector('.mobile-panel.is-active') ||
                  panelsWrap.querySelector('[data-panel="main"]');
    if(!target) return;
    current.classList.add('is-prev');
    current.classList.remove('is-active');
    target.classList.add('is-active');
    target.classList.remove('is-prev');
    panelsWrap.scrollTop = 0;
  }

  function goBack(){
    var current = panelsWrap.querySelector('.mobile-panel.is-active');
    if(current){
      current.classList.remove('is-active');
    }
    var main = panelsWrap.querySelector('[data-panel="main"]');
    main.classList.remove('is-prev');
    main.classList.add('is-active');
  }

  menuOpenBtn.addEventListener('click', openMenu);
  menuCloseBtn.addEventListener('click', closeMenu);
  overlay.addEventListener('click', closeMenu);

  panelsWrap.addEventListener('click', function(e){
    var gotoBtn = e.target.closest('[data-goto]');
    var backBtn = e.target.closest('[data-back]');
    if(gotoBtn){ gotoPanel(gotoBtn.getAttribute('data-goto')); }
    if(backBtn){ goBack(); }
  });

  // esc key closes menu
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && menu.classList.contains('is-open')){ closeMenu(); }
  });

 
})();
